import React from "react";

import { faPencilAlt } from "@fortawesome/pro-solid-svg-icons";

import FontAwesomeButton, { ButtonIcon } from "./FontAwesomeButton";

export default ({ onClick, disabled, dataTour = "edit", size }) => (
  <FontAwesomeButton
    data-tour={dataTour}
    type="button"
    onClick={onClick}
    disabled={disabled}
    size={size}
  >
    <ButtonIcon icon={faPencilAlt} />
  </FontAwesomeButton>
);
